export default class CookieConsentManager {
    readonly #dialogToggleButtons: HTMLElement[] = Array.from(
        document.querySelectorAll('[data-role="cookie-consent-toggle"]')
    );

    public initialize(): void {
        for (const dialogToggleButton of this.#dialogToggleButtons) {
            dialogToggleButton.addEventListener('click', this.#openCookieScriptDialog);
        }
    }

    readonly #openCookieScriptDialog = (): void => {
        const show = CookieScript?.instance?.show;
        if (typeof show === 'function') {
            try {
                show();
            } catch {
                /* intentionally swallow vendor errors */
            }
        }
    };
}
